import { Alert, Button, Card, Form } from '../../../ui';
import React, { Component, SyntheticEvent } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { requestPasswordReset } from '../../../../hooks/useAuth';
import { AuthFlowState, useAuthFlow } from '../../../../state/app-state';

interface PasswordResetPageProps {
  authFlow: AuthFlowState;
  requestPasswordReset: (email: string) => void;
}

interface PasswordResetPageState {
  email: string;
  emailTouched?: boolean;
  wrongEmail?: boolean;
  wrongCredentials?: boolean;
  emailNotFound?: boolean;
}

class PasswordResetPage extends Component<PasswordResetPageProps, PasswordResetPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      email: '',
      emailTouched: false,
    };
  }

  async handleSubmit(event: SyntheticEvent) {
    event.preventDefault();
    this.props.requestPasswordReset(this.state.email);
  }

  handleEmail(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const wrongEmail = !regex.test(value);
    this.setState({
      email: value,
      emailTouched: true,
      wrongEmail,
    });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Reset Password</title>
        </Helmet>

        {this.redirect()}

        <Card>
          <Card.Body>
            <h1 className="text-2xl font-bold text-gray-900 text-center mb-6">
              Forgot Your Password?
            </h1>
            <div>{this.showError()}</div>
            <div>{this.showForm()}</div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  showError() {
    if (this.state.emailNotFound) {
      return (
        <Alert variant="danger">
          Email not found. Please contact us at <a href="mailto:help@newslit.co">help@newslit.co</a>{' '}
          if you continue having issues.
        </Alert>
      );
    }
  }

  showForm() {
    return (
      <Form noValidate onSubmit={e => this.handleSubmit(e)}>
        <Form.Group controlId="email">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            isInvalid={this.state.wrongEmail}
            value={this.state.email}
            onChange={(e: any) => this.handleEmail(e)}
            placeholder="Email"
            required
          />
          <Form.Text muted>
            Enter the email address of your Newslit account. You will receive an email to reset your
            password.
          </Form.Text>
        </Form.Group>

        <Button
          disabled={
            this.props.authFlow.isRequestingPasswordReset ||
            !this.state.emailTouched ||
            this.state.wrongEmail
          }
          className="mt-4 w-full flex"
          variant="purple"
          type="submit"
        >
          {this.props.authFlow.isRequestingPasswordReset ? 'Sending...' : 'Send reset instructions'}
        </Button>
      </Form>
    );
  }

  redirect() {
    if (this.props.authFlow.isPasswordResetRequested) {
      return <Redirect to="/users/signin"></Redirect>;
    }
  }
}

const PasswordResetPageContainer = () => {
  const authFlow = useAuthFlow();
  return <PasswordResetPage authFlow={authFlow} requestPasswordReset={requestPasswordReset} />;
};

export default PasswordResetPageContainer;
